const FndUserRoleLovFields = [
    {
        name: '角色名称',
        code: 'roleName',
        column: true,
        defaultFilter: true,
        width: 200
    },
    {
        name: '角色编码',
        code: 'roleCode',
        align: 'center',
        column: true,
        defaultFilter: true,
        width: 200
    },
    {
        name: '描述',
        code: 'description',
        align: 'center',
        defaultFilter: true
    }
]
export default FndUserRoleLovFields;